import type { WiseEnvironment } from "@1js/wise-environments";
import { DataBoundary } from "./dataBoundary";

export function getCommonEndpointForEnvironment(
  environment: WiseEnvironment,
  dataBoundary?: DataBoundary
): string {
  switch (environment) {
    case "FASTFOOD":
      // ADO task 7222808 - not needed for compliance, but FIE1 should go to eurffc- endpoint
      return "https://ffc-common.online.office.com/suite/";
    case "MSIT":
      // ADO task 7222808 - not needed for compliance, but TIE1 and TNL1 should go to eurppc- endpoint
      return "https://ppc-common.online.office.com/suite/";
    case "PRODUCTION":
    default:
      if (dataBoundary === DataBoundary.EuropeanUnion) {
        return "https://euc-common.online.office.com/suite/";
      }

      return "https://common.online.office.com/suite/";
    case "GALLATIN":
      return "https://common.partner.officewebapps.cn/suite/";
    case "USGOV":
      return "https://gbc-common.online.office.com/suite/";
    case "TRAILBLAZER":
      return "https://common.gov.online.office365.us/suite/";
    case "PATHFINDER":
      return "https://common.dod.online.office365.us/suite/";
    case "AIRGAP08":
      return "https://common.wac.online.office.eaglex.ic.gov/suite/";
    case "AIRGAP09":
      return "https://common.wac.online.office.microsoft.scloud/suite/";
  }
}

// TODO (5985749 - AhrenYoung, JPitts): Work with Excel to see if we can send ULS data to common endpoints for bULS
export function getRemoteUlsEndpoint(
  environment: WiseEnvironment,
  dataBoundary?: DataBoundary
): string {
  return (
    getCommonEndpointForEnvironment(environment, dataBoundary) +
    "RemoteUls.ashx"
  );
}

export function getHealthEndpoint(
  environment: WiseEnvironment,
  sessionId: string | undefined,
  dataBoundary?: DataBoundary
): string {
  let url =
    getCommonEndpointForEnvironment(environment, dataBoundary) +
    "RemoteTelemetry.ashx";

  if (sessionId) {
    url += "?usid=" + sessionId;
  }

  return url;
}

export function getGraphEndpoint(environment?: WiseEnvironment): string {
  switch (environment) {
    case "GALLATIN": //China
      return "https://microsoftgraph.chinacloudapi.cn";
    case "TRAILBLAZER": //GCCHigh
      return "https://graph.microsoft.us";
    case "PATHFINDER": //DOD
      return "https://dod-graph.microsoft.us";
    case "AIRGAP08":
      return "https://graph.eaglex.ic.gov";
    case "AIRGAP09":
      return "https://graph.microsoft.scloud";
    default:
      return "https://graph.microsoft.com";
  }
}

export function getShareEndpoint(environment: WiseEnvironment): string {
  switch (environment) {
    case "TRAILBLAZER": //GCCHigh
      return "https://admin.onedrive.us/share";
    case "PATHFINDER": //DOD
      return "https://od.apps.mil/share";
    case "AIRGAP08":
      return "https://odweba.svc.ms.eaglex.ic.gov/share";
    case "AIRGAP09":
      return "https://odweba.svc.ms.microsoft.scloud/share";
    case "FASTFOOD":
    case "MSIT":
    case "PRODUCTION":
    case "GALLATIN": //China
    case "USGOV": //GCC
    default:
      return "https://www.odwebp.svc.ms/share";
  }
}

export function getOneNoteEndpoint(environment: WiseEnvironment): string {
  switch (environment) {
    case "GALLATIN": //China
      return "https://onenote.partner.office365.cn";
    case "USGOV": //GCC
      return "https://onenote.gcc.osi.office365.us";
    case "TRAILBLAZER": //GCCHigh
      return "https://onenote.osi.office365.us";
    case "PATHFINDER": //DOD
      return "https://onenote.osi.apps.mil";
    case "AIRGAP08":
      return "https://onenote.osi.eaglex.ic.gov";
    case "AIRGAP09":
      return "https://onenote.osi.microsoft.scloud";
    default:
      return "https://onenote.com";
  }
}
